import { useState } from "react";
import { HelpCircle } from "lucide-react";
import { hoverHelpOn, setHoverHelp } from "@/components/HoverHelp";

export const HoverHelpToggle = () => {
  const [on, setOn] = useState(hoverHelpOn);
  const flip = () => { setHoverHelp(!on); setOn(!on); };
  return (
    <button onClick={flip} aria-pressed={on} data-testid="hover-help-toggle"
      className={`flex items-center gap-1.5 text-[11px] px-2.5 py-1.5 rounded-md border transition-colors ${on ? "border-[#FFB800]/50 text-[#FFB800] bg-[#FFB800]/10" : "border-[#2A2E3D] text-slate-500 hover:text-slate-300"}`}>
      <HelpCircle className="w-3.5 h-3.5" />Hover help {on ? "on" : "off"}
    </button>
  );
};
